(function() {
  // ================================
  // Combined Bag JavaScript
  // Bundles functionality from:
  // - bag.bundle.js
  // - bag-scripts.liquid
  // - bag.liquid
  // without losing any functionality.
  // ================================

  // ----- Helper Functions (from bag-scripts.liquid) -----
  function isDelimitedArray(str) {
    return str.indexOf(",") !== -1;
  }

  function formatPriceDisplay(price) {
    // Assumes price is in cents
    return "$" + (price / 100).toFixed(2);
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // ----- SDG Namespace & Configuration (from bag.bundle.js) -----
  window.SDG = window.SDG || {};
  SDG.Bag = SDG.Bag || {};
  SDG.Bag.config = {
    cls: { active: 'is-active', empty: 'is-empty', expose: 'bag-exposed', loading: 'is-loading', error: 'error' },
    dom: { bag: 'bag', bag_btn: 'bagBtn', bag_content: 'js-bag-content', bag_empty: 'bagEmpty', bag_form: 'bagForm', bag_header: 'bagHeader', bag_inner: 'js-bag-inner', bag_close: 'bagContinue', donations: 'bagDonations', increment: '.js-increment', increment_input: '.js-increment-input', item: '.js-bag-item', item_messages: '.js-bag-item-messages', items: 'bagItems', remove: 'js-bag-item-remove', subtotal: 'bagSubtotal' },
    icon: { remove: 'icon--cart-close', add: 'icon--plus', substract: 'icon--minus' },
    img: { std: '132x', rtn: '264x', std_cart: '220x', rtn_cart: '440x' },
    show_event: 'click',
    timer: { hover: 1500, slide_up: 400 },
    url: { cart: '/cart.js', update: '/cart/change.js' },
    use: { count: true, swatch: false },
    exclude_selectors: '#bagBtn,.bag-btn-inner'
  };


  // ----- Count Module (bag-count.js) -----
  SDG.Bag.config_count = { dom: { count: 'bagBtnCount,bagBtnCountCart', count_page: 'bagBtnCount', page: 'your-shopping-cart' } };
  SDG.Bag.config = _.extend(SDG.Bag.config, SDG.Bag.config_count);
  SDG.Bag.Count = {
    count: null,
    get() { return this.count; },
    set(n) {
      const c = SDG.Bag.config;
      const $page = document.getElementById(c.dom.page);
      n = typeof n === 'string' ? parseInt(n, 10) : n;
      this.count = n;
      this.updateCount($page ? c.dom.count_page : c.dom.count, n);
    },
    updateCount(el, n) {
      if (isDelimitedArray(el)) {
        el.split(',').forEach(id => { const $count = document.getElementById(id.trim()); if ($count) $count.innerHTML = n; });
      } else {
        const $count = document.getElementById(el);
        if ($count) $count.innerHTML = n;
      }
    }
  };

  // ----- Empty State (bag-empty.js) -----
  SDG.Bag.empty = function(empty) {
    const c = SDG.Bag.config;
    const $bag = document.getElementById(c.dom.bag);
    if (!$bag) return;
    empty ? _.addClass($bag, c.cls.empty) : _.removeClass($bag, c.cls.empty);
  };

  // ----- Items Collection (bag-items.js) -----
  SDG.Bag.Items = {
    add(obj) { SDG.Data.bagItems.push(obj); },
    remove(variantId) { SDG.Data.bagItems = SDG.Data.bagItems.filter(o => o.id !== _.toNumber(variantId)); },
    update(variantId, prop, value) { const item = this.filterArray(variantId); if (item) item[prop] = value; },
    get(variantId, prop) { const item = this.filterArray(variantId); return item ? item[prop] : false; },
    empty() { SDG.Data.bagItems = []; },
    filterArray(variantId) { return SDG.Data.bagItems.filter(o => o.id === _.toNumber(variantId))[0]; }
  };

  // ----- Variant Helper (bag-variant.js) -----
  SDG.Bag.variant = function(variantId, variantsArray) {
    const vid = _.toNumber(variantId);
    const [variant] = variantsArray.filter(o => o.id === vid);
    return {
      getData() { return variant; },
      isMax(qty = 0) {
        const $item = document.getElementById(`bagItem${vid}`);
        const current = $item ? parseInt($item.querySelector(SDG.Bag.config.dom.increment_input).value, 10) : 0;
        return qty + current > variant.inventory_quantity;
      }
    };
  };

  // ----- Recalculate Subtotal (bag-recalc.js) -----
  SDG.Bag.recalc = function(price) {
    const c = SDG.Bag.config;
    const $sub = document.getElementById(c.dom.subtotal);
    if (typeof price !== 'undefined' && $sub) {
      $sub.innerHTML = numberWithCommas(formatPriceDisplay(price));
    }
  };

  // ----- Refresh Bag (bag-refresh.js) -----
  SDG.Bag.refresh = function(callback) {
    const c = SDG.Bag.config;
    const $bag = document.getElementById(c.dom.bag);
    const $list = document.getElementById(c.dom.items);
    function init() {
      _.ajax({ type: 'GET', url: c.url.cart, success: onSuccess, error: onError });
    }
    function onError() { console.error('Bag refresh error'); }
    function onSuccess(cart) {
      if (cart.items.length) { renderItems(cart); SDG.Bag.empty(false); }
      else { SDG.Bag.empty(true); }
      if (c.use.count) SDG.Bag.Count.set(cart.item_count);
      if (callback) callback();
    }
    function renderItems(data) {
      const { items, total_price } = data;
      _.removeClass($bag, c.cls.empty);
      $list.innerHTML = items.map(getItemHtml).join('');
      SDG.incrementer({ cb: SDG.Bag.updateItemQty });
      _.addEvent({ id: $list, className: c.dom.remove, event: 'click', fn: beforeRemove });
      SDG.minicartItemsHeight();
      SDG.Bag.recalc(total_price);
    }
    function beforeRemove(e) {
      e.preventDefault();
      const item = getItem(e.target);
      SDG.Bag.updateItemQty(item, 0);
    }
    init();
  };

  // ----- Build & Render Bag Items (from bag.liquid) -----
  function getItemHtml(item) {
    const { variant_title, variant_id, quantity, image, price, product_title, url, properties } = item;
    const variants = variant_title ? variant_title.split(' / ') : [];
    const [color = '', band = '', cup = ''] = variants;
    const prodUrl = `${url}?variant=${variant_id}`;
    const alt = `Photo -  ${item.title}`;
    const displayPrice = formatPriceDisplay(price);
    return `
<article class="bag-item js-bag-item" id="bagItem${variant_id}" data-variant-id="${variant_id}" data-qty="${quantity}">
  <div class="bag-item__photo">
    <a href="${prodUrl}" class="bag-item__photo-ir ir ir--product-photo">
      <img class="lazyautosizes" data-sizes="auto" data-widths="[132,264]" alt="${alt}" src="${image||'//cdn.shopify.com/s/files/1/no-image.gif'}">
    </a>
  </div>
  <div class="bag-item__info">
    <div class="bag-item__desc">
      <header class="bag-item__header"><div class="bag-item__title"><a href="${prodUrl}">${product_title}</a></div></header>
      <div class="bag-item__essentials">
        <p class="bag-item__variants"><span class="bag-item__variant">${color}</span><span class="bag-item__variant bag-item__variant-bra">${band}</span><span class="bag-item__variant bag-item__variant-bra">${cup}</span></p>
        <p class="bag-item__price"><span class="bag-item__original-price">${displayPrice}</span></p>
      </div>
    </div>
    <div class="bag-item__actions">
      <div class="bag-item__qty increment js-increment">
        <button type="button" class="btn-icon increment__btn increment__subtr js-increment-btn" data-action="remove">-</button>
        <label id="quantity-${variant_id}" class="screenreader">Quantity</label>
        <input type="number" class="increment__input js-increment-input" value="${quantity}" size="3" aria-labelledby="quantity-${variant_id}">
        <button type="button" class="btn-icon increment__btn increment__add js-increment-btn" data-action="add">+</button>
      </div>
      <a href="/cart/change/${variant_id}?quantity=0" class="bag-item__remove js-bag-item-remove btn-icon" role="button" data-variant-id="${variant_id}">
        <i class="icon icon--close-green-circle"></i>
      </a>
    </div>
    <div class="bag-item__messages js-bag-item-messages"></div>
  </div>
</article>`;
  }

  function getItem(el) {
    const itemEl = el.closest(SDG.Bag.config.dom.item);
    return { el: itemEl, id: itemEl && itemEl.getAttribute('data-variant-id') };
  }

  // ----- Update Item Qty (bag-update.js) -----
  SDG.Bag.updateItemQty = function(item, qty) {
    const c = SDG.Bag.config;
    const data = { id: _.toNumber(item.id), quantity: qty };
    const $el = document.getElementById(`bagItem${item.id}`);
    const msgEl = $el.querySelector(c.dom.item_messages);
    _.addClass($el, c.cls.loading);
    _.ajax({ type: 'POST', url: c.url.update, data, success: onSuccess, error: onError });
    function onSuccess(cart) {
      const variant = SDG.Bag.variant(item.id, SDG.Data.bagItems);
      const maxQty = variant.getData().inventory_quantity;
      if (qty === 0) { _.slideUp($el); setTimeout(() => $el.remove(), c.timer.slide_up); SDG.Bag.Items.remove(item.id); }
      else { _.removeClass($el, c.cls.loading); SDG.Bag.Items.update(item.id, 'quantity', qty); }
      if (cart.item_count === 0) SDG.Bag.empty(true);
      if (variant.isMax(qty)) { $el.querySelector(c.dom.increment_input).value = maxQty; SDG.Messages.init({ id: msgEl, msgs: { error: `<p>Sorry, ${maxQty} is max.</p>` }}).error(); }
      else { SDG.Messages.init({ id: msgEl }).clear(); }
      if (c.use.count) SDG.Bag.Count.set(cart.item_count);
      SDG.Bag.recalc(cart.total_price);
    }
    function onError() { console.warn('Error updating'); SDG.Bag.refresh(); }
  };

  // ----- Bag Init & Events (bag-init.js) -----
  SDG.Bag.timeout = null;
  SDG.Bag.open = () => SDG.minicart.toggleBag();
  SDG.Bag.close = () => SDG.minicart.toggleBag();
  SDG.Bag.waitToClose = () => { SDG.Bag.timeout = setTimeout(SDG.Bag.close, SDG.Bag.config.timer.hover); };
  SDG.Bag.init = function() {
    const c = SDG.Bag.config;
    function setup() { SDG.Bag.refresh(); addEvents(); }
    function addEvents() {
      document.addEventListener('keyup', e => { if (e.key === 'Escape') SDG.Bag.close(); });
      _.clickOutside({ callback: SDG.Bag.close, condition: () => _.hasClass(document.body, c.cls.expose), exclude_selectors: c.exclude_selectors, selector: '#' + c.dom.bag });
      if (c.show_event === 'mouseenter') { _.mq({ view: 'desktop', callback: bindHover }); _.windowResize(bindHover); }
      else bindClick();
    }
    function bindClick() { _.addEvent({ id: c.dom.bag_btn, event: 'click', fn: SDG.Bag.open }); }
    function bindHover() { const sel = c.dom.bag_btn + ',' + c.dom.bag; _.addEvent({ id: sel, event: 'mouseenter', fn: SDG.Bag.open }); _.addEvent({ id: sel, event: 'mouseleave', fn: SDG.Bag.waitToClose }); }
    setup();
  };

  // ----- Sticky Add-To-Bag -----
  function stickyAddtoBag() {
    const opts = { bagwrapper: 'addToBagWrapper', stickyClass: 'pv-actions__transition-out' };
    const btn = document.getElementById(opts.bagwrapper);
    if (!btn) return;
    new IntersectionObserver(entries => entries.forEach(e => btn.classList[e.isIntersecting ? 'add' : 'remove'](opts.stickyClass)), { threshold: 0.1 }).observe(document.querySelector('.pv-configs'));  
  }

  // ----- Fetch-based loadCart & updateCartItem (from bag.liquid) -----
  function loadCart() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      ['bagBtnCount','bagBtnCountCart'].forEach(id => { const el = document.getElementById(id); if (el) el.textContent = cart.item_count; });
      const container = document.getElementById('bagItems'); if (container) container.innerHTML = cart.items.map(i => getItemHtml(i)).join('');
      const sub = document.getElementById('bagSubtotal'); if (sub) sub.textContent = '$' + (cart.total_price/100).toFixed(2);
    }).catch(err => console.error('Error loading cart:', err));
  }

  function updateCartItem(variantId, newQty) {
    const fd = new FormData(); fd.append('id', variantId); fd.append('quantity', newQty);
    fetch('/cart/change.js',{ method:'POST', headers:{Accept:'application/json'}, body:fd })
      .then(r=>r.json()).then(()=>loadCart()).catch(e=>console.error('Error updating cart item:', e));
  }

  // ----- DOM Ready -----
  document.addEventListener('DOMContentLoaded', () => {
    // Bootstrap Data if missing
    window.SDG = SDG || {}; SDG.Data = SDG.Data || { bagItems: [], bagQtyError: null, assetUrl: '' };
    SDG.Bag.init();
    loadCart();
    document.querySelectorAll('.js-bag-toggle').forEach(btn => btn.addEventListener('click', () => document.body.classList.toggle('bag-exposed')));
    document.addEventListener('click', e => { if (!document.body.classList.contains('bag-exposed')) return; if (e.target.closest('#bag')||e.target.closest('#bagBtn')) return; document.body.classList.remove('bag-exposed'); });
    const bagItems = document.getElementById('bagItems'); if (bagItems) bagItems.addEventListener('click', e => {
      const btn = e.target.closest('.js-increment-btn'); if (!btn) return; const action = btn.getAttribute('data-action'); const itemEl = btn.closest('.bag-item'); const id = itemEl.getAttribute('data-variant-id'); const input = itemEl.querySelector('.js-increment-input'); let q = parseInt(input.value,10)||0; q = action==='add'?q+1:Math.max(0,q-1); input.value=q; updateCartItem(id,q);
    });
    stickyAddtoBag();
  });
})();
